module.exports = __webpack_public_path__ + "img/yq3.5cf7e7dc.png";